var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"width-height-percent aj-center"},[_c('barcode',{attrs:{"value":_vm.text,"width":_vm.width,"height":_vm.height,"fontSize":_vm.fontSize,"background":_vm.background,"lineColor":_vm.lineColor}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }